import { FormatStyle } from "./enums/SaveMode";
import { ModelMapAbstract } from "./ModelMapAbstract";

export class GuestHouseModel { }


export interface GuestHouseMaster {
    GHRequestID: number;
    EmployeeID: number;
    EmployeeCode: string;
    CompanyName:string;
    SiteName:string;
    PlantCode:string;
    DepartmentName:string;
    RequestedFor:string;
    RequestedBy:string;
    ContactNumber:string;
    FromLocation: string;
    ToLocation: string;
    FromDate: Date;
    ToDate: Date;
    TravelDate: Date;
    ExpectedCheckIn:Date;
    NoOfPerson: number;
    BookingPurpose: string;
    IsActive: boolean;
    IsCancel: boolean;
    CancelDateTime: Date;
    IsApproved: boolean;
    IsRejected: boolean;
    IsCabRequired: boolean;
    CabRequestID: number;
    CreatedBy: number;
    CreatedDate: Date;
    UpdateBy: number;
    UpdateDate: Date;
    RMName:string; //rohit 20-07-2023
    OtherRemark:string; //rohit 20-07-2023
    GHID:number;
    Phone:string;
    LocationId: number,
    RequestTypeId: number,
}
export interface GuestHouseAllocationMaster {
    CurrentPage: number;
    PageSize: number;
    UserID: number;
    EmployeeCode: string;
    DepartmentID: number;
    DesignationID: number;
    SiteID: number;
    DriverName: string;
    AllocateStatus: string;
}



export class GuestHouseAllocationList {
    EmployeeID: number;
    CabAllocateId: number;
    CabRequestID: number;
    GHRequestID:number;
    EmployeeName: string;
    EmployeeCode: string;
    SiteID: number;
    DesignationName: string;
    DepartmentName: string;
    PlantCode: string;
    SiteName: string;
    CompanyName: string;
    FromLocation: string;
    ToLocation: string;
    FromDate: Date;
    ToDate: Date;
    TravelDate: string;
    NoOfPerson: number;
    ReasonForTravel: string;
    DriverName: string;
    ContactNumber: string;
    ExpectedCheckIn: Date;
    AllocateStatus: string;
    Status: string;
    StatusClass: string;
    Remarks: string;
    TripStatus: string;
    TripRemarks: string;
    CreatedBy: number;
    CreatedDate: Date;
    UpdateBy: number;
    ApprovedDate: Date;
    ApproverName:string;
    ApproverRemarks:string;
    BookingPurpose:string;
    GHAddress:string;
    GHCareTaker:string;
    GHAllocateID:number;
    GHCheckInDate:Date;
    GHCheckOutDate:Date;
    GHContactNumber:string;
    GHName:string;
    GHID:number;
    GHSuiteNumber:string;
    //GuestHouseNo:string;
    OtherRemark:string; //rohit 20-07-2023
    RMName:string; //rohit 20-07-2023
    Phone:string;
    LocationId: number;
    RequestTypeId: number;
    Location: string;
    RequestedType:string;
}



export class ShowGuestHouseRequest {
    EmployeeID: number;
    CabAllocateID: number;
    CabRequestID: number;
    EmployeeName: string;
    EmployeeCode: string;
    SiteID: number;
    DesignationName: string;
    DepartmentName: string;
    PlantCode: string;
    SiteName: string;
    CompanyName: string;
    FromLocation: string;
    ToLocation: string;
    FromDate: Date;
    ToDate: Date;
    TravelDate: string;
    NoOfPerson: number;
    ReasonForTravel: string;
    DriverName: string;
    DriverNumber:string;
    ContactNumber: string;
    RTONumberPlate: string;
    AllocatedBy:string;
    AllocatedDate:string;
    ApprovedBy:string;
    ApprovedDate:string;
    ApprovedRemarks:string;
    CabRequestStatus:string;
    InwardBy:string;
    InwardDate:string;
    InwardRemarks:string;
    IsCabInword:string;
    IsCaboutword:string;
    OutwardBy:string;
    OutwardDate:string;
    OutwardRemarks:string;
    AllocateStatus: string;
    Status: string;
    StatusClass: string;
    Remarks: string;
    TripStatus: string;
    TripRemarks: string;
    CreatedBy: number;
    CreatedDate: Date;
    UpdateBy: number;
    UpdateDate: Date;
    OtherRemark:string; //rohit 20-07-2023
    GHAddress:string;
    GHCareTaker:string;
    LocationId: number;
    RequestTypeId: number;
    Location: string;
    RequestedType:string;

}

export class ViewGuestHouseRequest {
    EmployeeID: number;
    CabAllocateID: number;
    CabRequestID: number;
    GHRequestID: number;
    EmployeeName: string;
    EmployeeCode: string;
    FromLocation: string;
    ToLocation: string;
    FromDate: Date;
    ToDate: Date;
    TravelDate: string;
    NoOfPerson: number;
    ContactNumber: string;
    IsApproved:boolean;
    IsRejected:boolean;
    IsCancel:boolean;
    IsAllocated:boolean;
    Status: string;
    StatusClass: string;
    Remarks: string;
    OtherRemark:string; //rohit 20-07-2023
    LocationId: number;
    RequestTypeId: number;
    Location: string;
    RequestedType:string;
    FAStatus: number;
    WFID: number;
    AType: number;

}


export class GuestHouseBookingModelMap implements ModelMapAbstract {
    fieldSettings: (string | number)[][] = [
        ['Employee Code', 'EmployeeCode', FormatStyle.None],
        ['Employee Name', 'EmployeeName', FormatStyle.None],

        ['Company', 'CompanyName', FormatStyle.None],
        ['Department', 'DepartmentName', FormatStyle.None],
        ['Designation', 'DesignationName', FormatStyle.None],
        ['Plant/Unit', 'UnitName', FormatStyle.None],

        ['Contact No', 'ContactNumber', FormatStyle.None],
        // ['From Location', 'FromLocation', FormatStyle.None],
        // ['To Location', 'ToLocation', FormatStyle.None],
        ['From Date', 'FromDate', FormatStyle.DDMMYYYY],
        ['To Date', 'ToDate', FormatStyle.DDMMYYYY],
        ['Travel Date', 'TravelDate', FormatStyle.DDMMYYYY],
        ['Expected CheckIn Date', 'ExpectedCheckIn', FormatStyle.DDMMYYYY],   
        ['No Of Person', 'NoOfPerson', FormatStyle.None],    
        ['Meal Required', 'MealRequired', FormatStyle.None],
        ['Booking Purpose', 'BookingPurpose', FormatStyle.None],
        ['Other Remark' , 'OtherRemark', FormatStyle.None], // rohit 20-07-2023
        ['Status', 'Status', FormatStyle.None],
        ['CreatedBy', 'CreatedBy', FormatStyle.None]
    ];
  }


  
export class GHReviewModelMap implements ModelMapAbstract {
    fieldSettings: (string | number)[][] = [
        ['Employee Code', 'EmployeeCode', FormatStyle.None],
        ['Employee Name', 'EmployeeName', FormatStyle.None],
        ['Contact No', 'ContactNumber', FormatStyle.None],
        // ['From Location', 'FromLocation', FormatStyle.None],
        // ['To Location', 'ToLocation', FormatStyle.None],
        ['From Date', 'FromDate', FormatStyle.DDMMYYYY],
        ['To Date', 'ToDate', FormatStyle.DDMMYYYY],
        ['Travel Date', 'TravelDate', FormatStyle.DDMMYYYY],
        ['Expected CheckIn Date', 'ExpectedCheckIn', FormatStyle.DDMMYYYY],  
        ['No Of Person', 'NoOfPerson', FormatStyle.None],   
        ['Plant/Unit', 'UnitName', FormatStyle.None],
        ['Meal Required', 'MealRequired', FormatStyle.None],
        ['Booking Purpose', 'BookingPurpose', FormatStyle.None],
        ['Other Remark' , 'OtherRemark', FormatStyle.None], // rohit 20-07-2023
        ['Status', 'Status', FormatStyle.None],
        ['Approver Name', 'ApproverName', FormatStyle.None],
        ['Approver Remarks', 'ApproverRemarks', FormatStyle.None],
        ['Approved Date', 'ApprovedDate',  FormatStyle.DDMMYYYY],
        ['Approved Status', 'ApprovedStatus', FormatStyle.None],
        ['GH Name', 'GHName', FormatStyle.None],
       // ['GH Address', 'GHAddress', FormatStyle.None],
        ['GH Contact Number', 'GHContactNumber', FormatStyle.None],
        ['GH Room Number', 'GHSuiteNumber', FormatStyle.None],
        ['GH CheckInDate', 'GHCheckInDate', FormatStyle.DDMMYYYY],
        ['GH CheckOutDate', 'GHCheckOutDate', FormatStyle.DDMMYYYY],
        ['Remarks', 'Remarks', FormatStyle.None],
       // ['Trip Remarks', 'TripRemarks', FormatStyle.None],
       // ['Trip Status', 'TripStatus', FormatStyle.None],
        
    ];
  }


  export class GHAllocationModelMap implements ModelMapAbstract {
    fieldSettings: (string | number)[][] = [
        ['Employee Code', 'EmployeeCode', FormatStyle.None],
        ['Employee Name', 'EmployeeName', FormatStyle.None],
        ['Contact No', 'ContactNumber', FormatStyle.None],
        // ['From Location', 'FromLocation', FormatStyle.None],
        // ['To Location', 'ToLocation', FormatStyle.None],
        ['From Date', 'FromDate', FormatStyle.DDMMYYYY],
        ['To Date', 'ToDate', FormatStyle.DDMMYYYY],
        ['Travel Date', 'TravelDate', FormatStyle.DDMMYYYY],
        ['Expected CheckIn Date', 'ExpectedCheckIn', FormatStyle.DDMMYYYY],  
        ['No Of Person', 'NoOfPerson', FormatStyle.None],   
        ['Plant/Unit', 'PlantCode', FormatStyle.None],
        ['Meal Required', 'MealRequired', FormatStyle.None],
        ['Booking Purpose', 'BookingPurpose', FormatStyle.None],
        ['Other Remark' , 'OtherRemark', FormatStyle.None], // rohit 20-07-2023
        ['Status', 'Status', FormatStyle.None],
        ['Approver Name', 'ApproverName', FormatStyle.None],
        ['Approver Remarks', 'ApproverRemarks', FormatStyle.None],
        ['Approved Date', 'ApprovedDate',  FormatStyle.DDMMYYYY],
        ['Approved Status', 'ApprovedStatus', FormatStyle.None],
        ['GH Name', 'GHName', FormatStyle.None],
       // ['GH Address', 'GHAddress', FormatStyle.None],
        ['GH Contact Number', 'GHContactNumber', FormatStyle.None],
        ['GH Room Number', 'GHSuiteNumber', FormatStyle.None],
        ['GH CheckInDate', 'GHCheckInDate', FormatStyle.DDMMYYYY],
        ['GH CheckOutDate', 'GHCheckOutDate', FormatStyle.DDMMYYYY],
        ['Remarks', 'Remarks', FormatStyle.None],
        ['Trip Remarks', 'TripRemarks', FormatStyle.None],
        ['Trip Status', 'TripStatus', FormatStyle.None],
    ];
  }